import View from "../account/views/DeezerLoginView";
import components from "./components.js";
components.define("js-Deezer", View);